import React from "react";

// reactstrap components
import {
  Button,
  Row,
  Col,
} from "reactstrap";

import CardRestaurantConc from "components/Cards/concierge/CardRestaurantConc/index";

class Concierge extends React.Component {
  render() {
    return (
      <>
        <div className="content">
          <Row md="12">
            <Col md="9">
              <div className="typography-line">
                <h3>Hotéis, Motéis e Pousadas com QR Express</h3>
              </div>
            </Col>
            <Col md="3">
              <Button
                className="btn-round"
                href="../concierge/hotels/new"
                color="success"
                outline
              >
                <i className="fa fa-plus" />
                Novo Concierge
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <CardRestaurantConc
                source="motel-lasvegas-logo.png"
                name="Las Vegas Motel"
                adress="Vila Velha - ES"
                period="1"
              ></CardRestaurantConc>
            </Col>
            <Col md="4">
              <CardRestaurantConc
                source="motel-pop.png"
                name="Pop Motel"
                adress="Vila Velha - ES"
                period="1"
              ></CardRestaurantConc>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default Concierge;
